/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 15:10:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 15:53:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/slice/index.ts
 * @LastEditTime: 2021-03-23 22:28:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import arrayMove from 'array-move';

import {
  generateLinkImg,
  linkModulesContentValidation,
} from 'src/constrains/DraggableModules/tools';
import {
  EnumCollapseId,
  fixedCollapse,
} from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/common';
import { msg } from 'src/tools/message';
import { convertDataFromServerToRedux } from '../tools';

import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getLoaded as _getLoaded,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';

import {
  generateDefaultState as _generateDefaultState,
  //hasError,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';

import {
  getContentMaintenance,
  postContentMaintenance,
} from '@/src/request/salesChannel/content';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
export { EnumCollapseId };
export const request_getMaintenancePage = createAsyncThunk(
  'fetchSalesChannelContentMaintenancePage',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getContentMaintenance(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const request_submit = createAsyncThunk(
  'submitSalesChannelContentMaintenancePage',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await postContentMaintenance(body, params);
    return { response, isPrimary };
  },
);
const _defaultState = _generateDefaultState(fixedCollapse);
//console.log('_defaultState', _defaultState);
const defaultState = {
  ..._defaultState,
  ...defaultStatus,
  loading: false,
  display: false,
  contentUuid: '',
  storeUuid: '',
  uuid: '',
  salesChannelContent: '',
  salesChannelName: '',
  longCanvas: [],
  isDataValid: false,
  hasModified: false,
  collapseErrorMsgDisplay: {},
};

const salesChannelContentMaintenancePage = createSlice({
  name: 'salesChannelContentMaintenancePage',
  initialState: defaultState,
  reducers: {
    onCollapseOpen: (state, action) => {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    onAddCanvas: (state) => {
      state.hasModified = true;
      const item = generateLinkImg(1)[0];
      state.longCanvas.push(item);
    },
    onLongCanvasChange: (state, action) => {
      state.hasModified = true;
      const { index, data } = action.payload;
      state.longCanvas[index] = { ...state.longCanvas[index], ...data };
    },
    onLongCanvasMove: (state, action) => {
      state.hasModified = true;
      const { oldIndex, newIndex } = action.payload;
      state.longCanvas = arrayMove(state.longCanvas, oldIndex, newIndex);
    },
    onLongCanvasDelete: (state, action) => {
      state.hasModified = true;
      const index = action.payload;
      state.longCanvas.splice(index, 1);
    },
    onOpenCollapse: (state) => {
      state.display = true;
    },
    onTextChange: (state, action) => {
      state.hasModified = true;
      state.content = { ...state.content, ...action.payload };
    },
    validation: (state) => {
      let hasError = false;
      hasError = linkModulesContentValidation(state.longCanvas).hasError;
      state.isDataValid = !hasError;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(request_getMaintenancePage.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(request_getMaintenancePage.rejected, (state) => {
      state.loaded = true;
      const data = convertDataFromServerToRedux({}) || {};
      assData(state, data);
    });
    builder.addCase(request_getMaintenancePage.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;

      state.loading = false;
      const data = convertDataFromServerToRedux(response) || {};
      //
      assData(state, data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(request_submit.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(request_submit.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(request_submit.fulfilled, (state, action) => {
      const { response } = action.payload;
      const data = convertDataFromServerToRedux(response) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, data);
      state.hasModified = false;
    });
  },
});

export const getHasModified = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.hasModified,
    (hasModified) => {
      return hasModified;
    },
  );
};

export const getLongCanvas = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.longCanvas,
    (hasModified) => {
      return hasModified;
    },
  );
};

export const getText = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.content,
    (content) => {
      return content;
    },
  );
};

export const getDisplay = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.display,
    (v) => {
      return v;
    },
  );
};

export const getSalesChannelContent = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.salesChannelContent,
    (v) => v,
  );
};

export const getSalesChannelName = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.maintenance.salesChannelName,
    (v) => v,
  );
};

export const getUuid = () => {
  return createSelector(
    (state: Record<string, any>) => state.salesChannelContent.maintenance.uuid,
    (v) => v,
  );
};

export const getLoading = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.maintenance.loading,
    (v) => v,
  );
};

export const getState = () => {
  return _getState(EnumReducers.maintenance);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.maintenance, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.maintenance, id);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.maintenance);
};
export const getLoaded = () => {
  return _getLoaded(EnumReducers.maintenance);
};

export const {
  validation,
  onAddCanvas,
  onLongCanvasMove,
  onLongCanvasDelete,
  onLongCanvasChange,
  onOpenCollapse,
  onCollapseOpen,
  onErrorChange,
  onTextChange,
} = salesChannelContentMaintenancePage.actions;

export default salesChannelContentMaintenancePage.reducer;
